import { createRoot } from 'react-dom/client'
import App from './App.tsx'
import './index.css'
import { initializeSession } from './utils/sessionId.ts'

// Initialize session tracking
initializeSession();

createRoot(document.getElementById("root")!).render(<App />);
